import { actionTypes } from '../actions/session';
import { session as defaultState } from './default.json';

const handlers = {
  [actionTypes.SESSION_SET_LENGTH]: (state, action) => ({
    ...state,
    sessionLengthInMins: action.mins,
  }),
  [actionTypes.SESSION_RESET_LENGTH]: state => ({
    ...state,
    sessionLengthInMins: 30,
  }),
  [actionTypes.SESSION_UPDATE]: (state, action) => ({
    ...state,
    data: action.data,
  }),
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
